var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleStar = function SvgCircleStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F9",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-4.75c-.19 0-.366.11-.447.278L6.422 5.822 3.89 6.19a.502.502 0 0 0-.279.853L5.445 8.83l-.431 2.522a.499.499 0 0 0 .725.525L8 10.691l2.266 1.19a.5.5 0 0 0 .528-.037.5.5 0 0 0 .2-.488l-.431-2.522 1.83-1.787a.503.503 0 0 0-.278-.853l-2.534-.369L8.45 3.531a.5.5 0 0 0-.447-.278z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCircleStar;